<template>
  <BaseButton
    @click.prevent="isFollowed ? unfollowCollection() : followCollection()"
    size="small"
    color="outline-secondary"
    :test_id="`follow-button-${collection.id}`"
  >
    {{ isFollowed ? 'Following' : 'Follow' }}
    <LoadingCircle v-if="form.processing" size="12" class="tw-ml-1" />
    <component
      v-else
      :is="isFollowed ? CheckIcon : PlusIcon"
      class="tw-ml-1.5 tw-h-3 tw-w-3"
    />
  </BaseButton>
</template>

<script setup>
import BaseButton from '@/shared/components/BaseButton.vue'
import LoadingCircle from '@/shared/components/LoadingCircle.vue'
import PlusIcon from '@/assets/images/icons/plus.svg'
import CheckIcon from '@/assets/images/icons/check.svg'
import { OBJECT_PERMISSIONS } from '@/shared/data/permissionSystem.js'
import { useForm } from '@inertiajs/vue3'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import { ref } from 'vue'
import { notify } from '@kyvg/vue3-notification'

const props = defineProps({
  collection: {
    type: Object,
    required: true,
  },
})

const { hasObjectPermissions } = usePermissionSystem()

const form = useForm({})
const isFollowed = ref(
  hasObjectPermissions(
    props.collection,
    OBJECT_PERMISSIONS.COLLECTIONS.FOLLOWING,
  ),
)

const followCollection = () => {
  form.post(`/collections/${props.collection.id}/follows`, {
    preserveScroll: true,
    onSuccess: () => {
      notify({
        text: `You are now following ${props.collection.name}.`,
        type: 'success',
      })
      isFollowed.value = true
    },
  })
}

const unfollowCollection = () => {
  form.delete(`/collections/${props.collection.id}/follows`, {
    preserveScroll: true,
    onSuccess: () => {
      notify({
        text: `You are no longer following ${props.collection.name}.`,
        type: 'success',
      })
      isFollowed.value = false
    },
  })
}
</script>
